import React, { Component } from 'react';
import _ from 'lodash';
import DropdownMenu from 'react-dd-menu';
import './dropdown-menu.scss';

export default class DropDownMenu extends Component {
  constructor() {
    super();
    this.state = {
      isMenuOpen: false
    };
  }

  toggle = () => {
    this.setState({ isMenuOpen: !this.state.isMenuOpen });
  };

  close() {
    this.setState({ isMenuOpen: false });
  }

  render() {
    const menuOptions = _.assign(
      {
        isOpen: this.state.isMenuOpen,
        close: this.close.bind(this),
        align: 'right'
      },
      this.props.menuOptions || {}
    );

    const { menuItems } = this.props;
    const Toggle =
      this.props.toggle ||
      (({ onClick }) => (
        <button type="text" onClick={onClick}>
          Click me!
        </button>
      ));

    return (
      <div className="c-dropdown">
        <DropdownMenu {...menuOptions} toggle={<Toggle onClick={this.toggle} />}>
          {menuItems.map(item => (
            <li onClick={item.onClick} key={item.id} role="presentation">
              {item.label}
            </li>
          ))}
        </DropdownMenu>
      </div>
    );
  }
}
